import { gql } from "@apollo/client";
import { values } from "./helper";
export const typeDef = gql`
  type Advert {
    id: ID!
    name: String
    description: String
    url: String
    targetBlank: Boolean
    sort: Int
    thumbnailUrl: String
    copyright: String
  }
`;
export const resolvers = {
  Advert: {
    name: ad => ad.display_name,
    targetBlank: ad => values(ad, "target_blank"),
    sort: ad => values(ad, "sort"),
    thumbnailUrl: ad => {
      var _ad$creatives;
      return ad === null || ad === void 0 || (_ad$creatives = ad.creatives) === null || _ad$creatives === void 0 || (_ad$creatives = _ad$creatives[0]) === null || _ad$creatives === void 0 ? void 0 : _ad$creatives.url;
    },
    copyright: ad => {
      var _ad$creatives2;
      return ad === null || ad === void 0 || (_ad$creatives2 = ad.creatives) === null || _ad$creatives2 === void 0 || (_ad$creatives2 = _ad$creatives2[0]) === null || _ad$creatives2 === void 0 ? void 0 : _ad$creatives2.copyright;
    }
  }
};